// extracted by mini-css-extract-plugin
module.exports = {"main":"DownloadList_main___MKhZ","title":"DownloadList_title__Xx2dg","content":"DownloadList_content__ZyikN","rotation":"DownloadList_rotation__F7MG9"};